import React, { useState } from 'react';
import ColorSchemesExample from '../../gear/navbar/BasicExample';

import './gallery.css'; // Import a separate CSS file for styling

const Gallery = () => {
    const imagePaths = require.context('./gallery', false, /\.(png|jpe?g|svg)$/);
    const images = imagePaths.keys().map((imagePath) => imagePaths(imagePath));

    const [currentIndex, setCurrentIndex] = useState(0);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrevious = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    return (
        <div className="gallery-container">
            <div className="parabola-info-block">
                <p>Now closed Parabola gallery. Ivanovo</p>
            </div>
            <div className="image-container">
                <img
                    src={images[currentIndex]}
                    alt={`${currentIndex}`}
                    className="gallery-image"
                />
            </div>
            <div className="button-container">
                <button className="gallery-button" onClick={handlePrevious}>
                    Previous
                </button>
                <button className="gallery-button" onClick={handleNext}>
                    Next
                </button>
            </div>
        </div>
    );
};

const App = () => {
    return (
        <div>
            <ColorSchemesExample />
            <Gallery />
        </div>
    );
};

export default App;